<text-search>

    <!-- Desktop display    -->
    <div class="d-none d-lg-block">
        <div class="form-group form-group-default">
            <input onchange="{onChange}" ref="searchBar" type="text" placeholder="Search ..." value="{opts.term}" class="form-control">
        </div>
    </div>



    <!-- Mobile display -->
    <div class="d-lg-none mr-2" style="display: initial">
        <a href="#" data-toggle="dropdown" id="search-dropdown">
            <i class="fa fa-search"></i>
        </a>

        <div class="dropdown-menu w-100 pl-2 pr-2" aria-labelledby="search-dropdown">
            <div class="form-group form-group-default">
                <input onchange="{onChangeMobile}" ref="searchBarMobile" type="text" placeholder="Search ..." value="{opts.term}" class="form-control">
            </div>
        </div>
    </div>

    <script>

        // import utils

        // tag instance
        const tag = this;

        tag.onSearch = !!(opts.onSearch) ? opts.onSearch : null;

        tag.onChange = (event) => {

            event.preventUpdate = true;

            let term = tag.refs.searchBar.value;
            console.log(term);

            if (tag.onSearch)
                return tag.onSearch(term);
        };

        tag.onChangeMobile = (event) => {

            event.preventUpdate = true;

            let term = tag.refs.searchBarMobile.value;
            console.log(term);

            if (tag.onSearch)
                return tag.onSearch(term);
        }
    </script>
</text-search>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/nav-bar/text-search.tag.html